<template>
    <component
        :is="iconComponent"
        v-if="iconComponent"
        :size="Number(size)"
        :fillColor="fillColor"
        v-bind="$attrs"
    />
    <span
        v-else
        class="icon-fallback"
        >{{ name }}</span
    >
</template>

<script>
import { markRaw } from 'vue'

const iconModules = import.meta.glob('/node_modules/vue-material-design-icons/*.vue')

const iconMap = {}
Object.keys(iconModules).forEach((path) => {
    const fileName = path.split('/').pop().replace('.vue', '')
    const kebabName = fileName.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()
    iconMap[kebabName] = path
})

export default {
    name: 'CoreIcon',
    inheritAttrs: false,

    props: {
        name: {
            type: String,
            required: true,
        },
        size: {
            type: [Number, String],
            default: 24,
        },
        fillColor: {
            type: String,
            default: 'currentColor',
        },
    },

    data() {
        return {
            iconComponent: null,
        }
    },

    mounted() {
        this.loadIcon(this.name)
    },

    watch: {
        name(newName) {
            this.loadIcon(newName)
        },
    },

    methods: {
        async loadIcon(iconName) {
            if (!iconName) return

            const iconPath = iconMap[iconName]

            if (iconPath) {
                try {
                    const module = await iconModules[iconPath]()
                    this.iconComponent = markRaw(module.default)
                } catch (error) {
                    console.error(`Error loading icon '${iconName}':`, error)
                    this.iconComponent = null
                }
            } else {
                console.warn(`Icon '${iconName}' not found in available icons.`)
                this.iconComponent = null
            }
        },
    },
}
</script>
